var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 89.6 90.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 9.4,
    y1: 61.3,
    x2: 91.9,
    y2: 31.2,
    gradientTransform: "translate(-7.3 9.7) rotate(-11)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eddc97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#c89532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#eddc97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f9eec9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#eddc97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c89532"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.4.5l15.9,28.7c.2.4.6.5,1,.5l32.2-6.3c.9-.2,1.5.9.9,1.5l-22.4,24c-.3.3-.3.7-.1,1.1l15.9,28.7c.4.8-.4,1.7-1.2,1.3l-29.7-13.9c-.4-.2-.8,0-1.1.2l-22.4,24c-.6.7-1.7.1-1.6-.7l4-32.6c0-.4-.2-.8-.5-1L.5,42.2c-.8-.4-.7-1.6.2-1.7l32.2-6.3c.4,0,.7-.4.7-.8L37.7.8c.1-.9,1.3-1.1,1.7-.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftStar);
export default __webpack_public_path__ + "static/media/left-star.9317053ed02acc92a45e5f5a7cf194f8.svg";
export { ForwardRef as ReactComponent };